<template>
  <div id="app">
    <div class="chrome">
      <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container">
          <router-link :to="'/'" class="navbar-brand"><img src="/static/images/logo.png"></router-link>
        </div>
      </nav>
      <router-view/>
      <footer class="footer">
        <div class="container">
          <span class="text-muted">© 2018 ByteArk. All Rights Reserved.</span>
          <span class="float-right">ติดต่อเรา : info@byteark.com, (66) 02-026-3326 กด 4</span>
<!--           <span class="float-right mr-4">
            <router-link :to="'about'">ByteArk คำนวน ISP SPEED INDEX อย่างไร ?</router-link>
          </span> -->
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style lang="scss">
@import './assets/scss/app.scss';

#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue